import { getListings } from '../getListings';
import { getActiveProduct } from '../selectors';

export const LISTING_REFRESH_SOCKET_EVENTS = [
  'products.listingRefresh.complete',
  'products.listingRefresh.failed',
];

export const shouldRefetchListingsOnRefreshEvent = ({
  masterProductId,
  openMasterProductId,
}) => {
  if (!masterProductId || !openMasterProductId) return false;
  return String(openMasterProductId) === String(masterProductId);
};

export const handleListingRefreshSocketEvent = (event, {
  dispatch,
  getLocation = () => ({ pathname: window.location.pathname }),
}) => {
  const masterProductId = event?.data?.masterProductId;
  const openProduct = getActiveProduct(getLocation());

  if (!shouldRefetchListingsOnRefreshEvent({
    masterProductId,
    openMasterProductId: openProduct?.productId,
  })) {
    return;
  }

  dispatch(getListings({
    masterProductId,
    masterVariantId: openProduct?.variantId || null,
    skipLiveRefreshPoll: true,
  }));
};
